import React from "react";
import { ImageWithInformation } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { BannerInfo } from "@/components/PageHome/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./Banner.module.scss";

interface BannerProps {
  data: BannerInfo;
  userAgent: DeviceInfo;
}

const Banner: React.FC<BannerProps> = ({ data, userAgent }) => {
  const { Title, Description, Image, CTAText, CTAUrl, ImageOpacity } = data;
  const router = useRouter();

  return (
    <div className={styles.root}>
      <ImageWithInformation
        imageUrl={Image?.data?.attributes?.url}
        rawSubTitle={Description}
        rawTitle={Title}
        onClick={() => {
          if (CTAUrl) {
            router.push(CTAUrl);
          }
        }}
        redirectUrl={CTAUrl}
        ctaText={CTAText}
        isAyurvedic
        wrapperHeight={userAgent?.isMobile ? "278px" : "372px"}
        contentClassName={`container ${styles.ayurvedaBanner}`}
        isImageCover
        overlayOpacity={`${ImageOpacity}`}
      />
    </div>
  );
};

export default Banner;
